module.exports = __webpack_public_path__ + "static/media/ConduireGame.99d14679.png";